/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const NOT_HELD_WITH_NEXT = battleType => (
    <FormattedMessage
        id='schedule.not_held_text'
        defaultMessage='{battleType} не проводятся, ближайшие:'
        values={{ battleType }}
    />
)

export const NOT_HELD = battleType => (
    <FormattedMessage
        id='schedule.not_held'
        defaultMessage='{battleType} не проводятся.'
        values={{ battleType }}
    />
)

export const COMING = (
    <FormattedMessage
        id='players_matching.NEXT_BATTLES'
        defaultMessage='Ближайшие:'
    />
)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/BattleRoomsSchedule/components/BattlesNotHeldMessage/translations.js